import React, { createContext, useState, useCallback, useContext } from "react";
import { Snackbar, Alert } from "@mui/material";

const MessageContext = createContext();

export const useMessage = () => useContext(MessageContext);

export const MessageProvider = ({ children }) => {
  const [messageInfo, setMessageInfo] = useState({
    open: false,
    text: "",
    severity: "info",
  });

  const showMessage = useCallback((text, severity = "info") => {
    setMessageInfo({ open: true, text, severity });
  }, []);

  const handleClose = (event, reason) => {
    if (reason === "clickaway") return;
    setMessageInfo((prev) => ({ ...prev, open: false }));
  };

  return (
    <MessageContext.Provider value={{ showMessage }}>
      {children}
      <Snackbar
        open={messageInfo.open}
        autoHideDuration={3000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={handleClose}
          severity={messageInfo.severity}
          variant="filled"
        >
          {messageInfo.text}
        </Alert>
      </Snackbar>
    </MessageContext.Provider>
  );
};
